var _circle, _path, _path2, _circle2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17.35,
    stroke: "#F0F2F5",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0276 21.4527L26.7267 21.1466V15.4532C26.7066 11.3005 23.6372 7.87222 19.6951 7.37226V6.27032C19.6951 5.70914 19.2437 5.25 18.692 5.25C18.1403 5.25 17.6889 5.70914 17.6889 6.27032V7.37226C15.9235 7.59673 14.2884 8.39258 13.0145 9.69859C11.4999 11.2393 10.6673 13.3003 10.6673 15.4838V21.1568L10.3864 21.4527C9.51375 22.3403 9.26298 23.6157 9.73443 24.7891C10.2059 25.9523 11.2691 26.6767 12.513 26.6767H24.9011C26.1349 26.6767 27.1981 25.9523 27.6796 24.7891C28.1511 23.6259 27.9103 22.3505 27.0376 21.4527H27.0276ZM25.8139 24.0035C25.7537 24.1463 25.5129 24.6259 24.891 24.6259H12.5029C11.881 24.6259 11.6403 24.1463 11.5801 23.9933C11.5199 23.8504 11.3594 23.33 11.8008 22.8811L12.3826 22.2893C12.5732 22.0955 12.6735 21.8404 12.6735 21.5649V15.4736C12.6634 13.8309 13.2853 12.2902 14.4289 11.1372C15.5623 9.97408 17.077 9.34148 18.692 9.34148C22.0122 9.34148 24.7105 12.0861 24.7105 15.4634V21.5853C24.7205 21.8506 24.8208 22.1159 25.0114 22.2995L25.6032 22.9015C26.0446 23.3505 25.8741 23.8606 25.8139 24.0137V24.0035Z",
    fill: "#393B4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.713 28.708H16.6906C16.1389 28.708 15.6875 29.1672 15.6875 29.7283C15.6875 30.2895 16.1389 30.7486 16.6906 30.7486H20.713C21.2647 30.7486 21.716 30.2895 21.716 29.7283C21.716 29.1672 21.2647 28.708 20.713 28.708Z",
    fill: "#393B4A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.9596,
    cy: 10.2083,
    r: 3.54167,
    fill: "#20C3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notificationIcon.b70fa2a25c5c5621aa3546f8f072d6c5.svg";
export { ForwardRef as ReactComponent };